import { Button, Popover, Stack } from "@mantine/core";
import { IconChevronDown, IconSparkles } from "@tabler/icons-react";
import CreateFieldAI from "./create-field/CreateFieldAI";
import EnrichDatafield from "../actions/enrich/EnrichDatafield";
import { useState } from "react";
import QuickCampaign from "./quickCampaign/QuickCampaign";
import IceBreaker from "../actions/IceBreaker";
import { useLanguage } from "../../../../stores/LanguageStore";
import ListTranslate from "../actions/ListTranslate";

const AIActions = ({ handleNewField, onFinish, currentList, isMinimized }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const handleFieldCreate = () => {
    handleClose();
    handleNewField();
  };

  return (
    <Popover
      opened={opened}
      withinPortal={false}
      onChange={setOpened}
      keepMounted
    >
      <Popover.Target>
        <Button
          leftSection={
            <IconSparkles
              size={28}
              fill="var(--mantine-color-primary-6)"
              stroke={0}
            />
          }
          variant="light"
          fz={16}
          rightSection={<IconChevronDown size={20} />}
          ml={"auto"}
          radius={"md"}
          size="md"
          className="main-list-action"
          px={24}
          onClick={handleOpen}
        >
          {isMinimized && lang.prospects.ai_actions}
        </Button>
      </Popover.Target>

      <Popover.Dropdown component={Stack}>
        <QuickCampaign current={currentList} inMenu />

        <CreateFieldAI onFinish={handleFieldCreate} />

        <IceBreaker
          current={currentList}
          onFinish={onFinish}
          inMenu
          closeMenu={handleClose}
        />

        <EnrichDatafield onFinish={onFinish} closeMenu={handleClose} />

        <ListTranslate
          current={currentList}
          onFinish={onFinish}
          closeMenu={handleClose}
        />
      </Popover.Dropdown>
    </Popover>
  );
};

export default AIActions;
